import { gql } from 'graphql-tag';

export const LOAD_CUSTOM_FIELD_VALUES_BY_IDS = gql`
  query Id343bbc20892eb87b321162c6db756e73(
    $companyId: ID!
    $customFieldId: ID!
    $customFieldValueIds: [ID!]!
  ) {
    __typename
  }
`;

export const LOAD_CUSTOM_FIELDS_VALUES_BY_IDS_MULTIPLE = gql`
  query Idd3a9c30e343d2319e9356216fc58bab7(
    $companyId: ID!
    $customFieldIds: [ID!]!
    $customFieldValueIds: [ID!]!
  ) {
    __typename
  }
`;

export const SEARCH_CUSTOM_FIELD_VALUES = gql`
  query Id4766dda47bb69add3e65e44630bea052(
    $companyId: ID!
    $customFieldId: ID!
    $search: String!
  ) {
    __typename
  }
`;

export const GET_BY_IDS_EXPENSE_ACCOUNTS = gql`
  query Ida02c696c9f6103fdbb7629bbec7a079e(
    $companyId: ID!
    $ids: [ID!]!
    $includeArchived: Boolean
  ) {
    __typename
  }
`;

export const GET_BY_IDS_TAX_ACCOUNTS = gql`
  query Id771f1252a47583717600e99e4d9b145f(
    $companyId: ID!
    $ids: [ID!]!
    $includeArchived: Boolean
  ) {
    __typename
  }
`;

export const SEARCH_MEMBERS = gql`
  query Id2e3270263d755bf04dc85068d93625a2($companyId: ID!, $search: String!) {
    __typename
  }
`;

export const SEARCH_PAYABLE_ACCOUNTS = gql`
  query Id3ad2737ef6148bd1e0734dffd6937c89($companyId: ID!, $search: String!) {
    __typename
  }
`;

export const GET_BY_IDS_PAYABLE_ACCOUNTS = gql`
  query Id80694c40e3e0c25d551d8f295c9f2b55($companyId: ID!, $ids: [String]) {
    __typename
  }
`;

export const SEARCH_TEAMS = gql`
  query Idb822239acc5de9a979a80da5f1e84572($companyId: ID!, $search: String!) {
    __typename
  }
`;

export const GET_TEAMS = gql`
  query Id8231f3ee4fd69eb74b10b6415d6b0d74($companyId: ID!, $ids: [ID!]!) {
    __typename
  }
`;
